import React from 'react';

import { 
    createStyles, 
    makeStyles, 
    Theme, 
    Typography, 
    Button 
} from '@material-ui/core';

import i18n from '../../services/localization/i18n';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            flexGrow: 1,
            marginTop:10,
            marginBottom: 10,
            marginRight: 20,
        },
        circleLeft : {
            position: "absolute",
            [theme.breakpoints.down('xl')]: {
                right: 0,
                width: 0,
            },
            [theme.breakpoints.up(1550)]: {
                left: -400,
                width: 570,
            },
            [theme.breakpoints.up('xl')]: {
                left: -460,
                width: 720,
            },

            top: 2040
        },
        circleRight : {
            position: "absolute",
            [theme.breakpoints.down('lg')]: {
                right: 0,
                width: 0,
            },
            [theme.breakpoints.up('lg')]: {
                right: -400,
                width: 570,
            },
            [theme.breakpoints.up('xl')]: {
                right: -285,
                width: 570,
            },
        },
        circleRightLast : {
            position: "absolute",
            [theme.breakpoints.down('lg')]: {
                right: 0,
                width: 0,
            },
            [theme.breakpoints.up('lg')]: {
                right: -400,
                width: 570,
            },
            [theme.breakpoints.up('xl')]: {
                right: -360,
                width: 720,
            },
            top: 3000,
        },
        calling: {
            marginBottom: 50,
            marginTop: 40,
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            [theme.breakpoints.down('sm')]: {
                flexDirection: "column",
            },
        },
        collaboration: {
            marginBottom: theme.spacing(6),
            marginTop: theme.spacing(5),
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            [theme.breakpoints.down('sm')]: {
                flexDirection: "column-reverse",
            }
        },
        content: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            [theme.breakpoints.up('xl')]: {
                maxWidth: 1140,
            },
        },
        image: {
            width: "100%"
        },
        interviewer: {
            marginBottom: 50,
            marginTop: 40,
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            [theme.breakpoints.down('sm')]: {
                flexDirection: "column",
            }
        },
        head: {
            marginBottom: 20,
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(5),
                fontSize: "40px",
            },
        },

        recruiter: {
            marginBottom: 50,
            marginTop: 40,
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            [theme.breakpoints.down('sm')]: {
                flexDirection: "column-reverse",
            }
        },
        root: {
            backgroundColor: "#ffffff",
            display: "flex",
            flexDirection: "row",
            flexGrow: 1,
            justifyContent: "center",
            paddingBottom: theme.spacing(6),
            paddingTop: theme.spacing(4),
        },
        subhead: {
            margin: theme.spacing(0.5),
            marginBottom: theme.spacing(1.5),
            [theme.breakpoints.down('sm')]: {
                width: "100%",
                fontSize: 20,   
            },
        },
        section: {
            display: "flex",
            flexDirection: "row",
            [theme.breakpoints.down('sm')]: {
                flexDirection: "column",
                marginLeft: theme.spacing(2)
            },
        },
        sectionDescription: {
            padding: theme.spacing(5),

            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(1),
            }
        },
        sectionPicture: {
            width: "60%",
            padding: theme.spacing(8),
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(),
                width: "100%",
              },
              [theme.breakpoints.up('sm')]: {
                width: "50%",
              },
              [theme.breakpoints.up('lg')]: {
                width: "60%"
              },
        },
        sectionSubtitle: {
            margin: 5,
        },
        sectionTitle: {
            margin: 5,
        },
        sectionBody: {
            marginLeft: 5,
            marginRight: 5,
        },

        spacer: {
            display: "block",
            height: theme.spacing(4),
            marginBottom: theme.spacing(2.5),
            [theme.breakpoints.down('sm')]: {
                display: "none",
            },

        },
        title: {
            margin: "0 auto",
            width: 740,
            textAlign: "center",
            marginBottom: 20,
            [theme.breakpoints.down('sm')]: {
                width: "100%",
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(1)
            },
        }
    })
);

const UseCases: React.FC = () => {
    const classes = useStyles();

    const TitleSection : React.FC = () => {
        return <div className={classes.title}>
                <Typography variant="h2" className={classes.head}>
                    { i18n.t('usecase_title_head') }
                </Typography>
                <Typography variant="h5"  className={classes.subhead}>
                    { i18n.t('usecase_title_subhead') }
                </Typography>
            </div>;
    }

    const InterviewerSection : React.FC = () => {
        return <section className={classes.section}>
                <div className={classes.interviewer} >

                  <div className={classes.sectionDescription}>
                    <Typography variant="h6" color="secondary"className={classes.sectionTitle}>
                        { i18n.t('usecase_interviewer_title') }
                    </Typography>
                    <Typography variant="h4" className={classes.sectionSubtitle}>
                        { i18n.t('usecase_interviewer_subtitle') }
                    </Typography>
                    <Typography variant="h5" className={classes.sectionBody}>
                        { i18n.t('usecase_interviewer_body') }
                    </Typography>
                    <Button className={classes.button} variant="outlined" color="primary" disabled={true}>
                    { i18n.t('usecase_interviewer_learnmore') }
                    </Button>
                  </div>
                  <div className={classes.sectionPicture}>
                    <img className={classes.image} 
                         src="https://meet-cdn.azureedge.net/assets/content/s2.png" 
                         alt={ i18n.t('usecase_interviewer_imgalt') } />
                  </div>
                </div>
        </section>;
    }

    const CollaborationSection : React.FC = () => {
        return  <section className={classes.section}>
            <div className={classes.collaboration}>
                <div className={classes.sectionPicture}>
                    <img className={classes.image} 
                         src="https://meet-cdn.azureedge.net/assets/content/s3.png" 
                         alt={ i18n.t('usecase_collaboration_imgalt') } />
                </div>
                <div className={classes.sectionDescription}>
                    <Typography variant="h6" color="secondary"className={classes.sectionTitle}>
                        { i18n.t('usecase_collaboration_title') }
                    </Typography>
                    <Typography variant="h4" className={classes.sectionSubtitle}>
                        { i18n.t('usecase_collaboration_subtitle') }
                    </Typography>
                    <Typography variant="h5" className={classes.sectionBody}>
                        { i18n.t('usecase_collaboration_body_one') } <br/ >
                        { i18n.t('usecase_collaboration_body_two') }
                    </Typography>
                    <Button className={classes.button} variant="outlined" color="primary" disabled={true}>
                    { i18n.t('usecase_collaboration_learnmore') }
                    </Button> 
                </div>

            </div>
        </section>;
    }

    const RecruiterSection : React.FC = () => {
        return <section className={classes.section}>
                <div className={classes.recruiter} >
                  <div className={classes.sectionPicture}>
                    <img className={classes.image} src="https://meet-cdn.azureedge.net/assets/content/s4.png" 
                        alt={ i18n.t('usecase_recruiter_imgalt') } />
                  </div>
                  <div className={classes.sectionDescription}>
                    <Typography variant="h6" color="secondary"className={classes.sectionTitle}>
                        { i18n.t('usecase_recruiter_title') }
                    </Typography>
                    <Typography variant="h4"  className={classes.sectionSubtitle}>
                        { i18n.t('usecase_recruiter_subtitle') }
                    </Typography>
                    <Typography variant="h5" className={classes.sectionBody}>
                        { i18n.t('usecase_recruiter_body') }
                    </Typography>
                    <Button className={classes.button} variant="outlined" color="primary" disabled={true}>
                        { i18n.t('usecase_recruiter_learnmore') }
                    </Button>
                  </div>
                </div>
        </section>;
    }

       
    const VideoCallSection : React.FC = () => {
        return  <section className={classes.section}>
            <div className={classes.calling}>

                <div className={classes.sectionDescription}>
                    <Typography variant="h6" color="secondary"className={classes.sectionTitle}>
                        { i18n.t('usecase_call_title') }
                    </Typography>
                    <Typography variant="h4"  className={classes.sectionSubtitle}>
                        { i18n.t('usecase_call_subtitle') }
                    </Typography>
                    <Typography variant="h5" className={classes.sectionBody}>
                        { i18n.t('usecase_call_body_one') } <br /> 
                        { i18n.t('usecase_call_body_two') }
                    </Typography>
                    <Button className={classes.button} variant="outlined" color="primary" disabled={true}>
                        { i18n.t('usecase_call_learnmore') }
                    </Button>
                </div>
                <div className={classes.sectionPicture}>
                    <img className={classes.image} 
                         src="https://meet-cdn.azureedge.net/assets/content/s5.png" 
                         alt={ i18n.t('usecase_call_imgalt') } />
                </div>
            </div>
        </section>;
    }



    return (
        <section className={classes.root} >
            <div className={classes.content}>
                <TitleSection />
                <div className={classes.circleRight}>
                    <img className={classes.image} src="https://meet-cdn.azureedge.net/assets/content/c1.png" alt="Decorative circle" />
                </div>
                <div className={classes.spacer} />

                <VideoCallSection />

                <CollaborationSection />

                <InterviewerSection />
                <div className={classes.circleLeft}>
                    <img className={classes.image} src="https://meet-cdn.azureedge.net/assets/content/c1.png" alt="Decorative circle" />
                </div>

                <RecruiterSection />

              </div>
        </section>
    );
  }
  
  export default UseCases;